/*------------------------------------------------
// File Name:PDM_MA_Path.js
// File Description:PDM_MA_Path store方法
// Author:zxl
// Create Time:2023/07/11 16:27:07
//------------------------------------------------*/

import {
    GetPDM_MA_PathList,
    GetPDM_MA_PathListByPage,
    GetPDM_MA_PathEntity,
    CreatePDM_MA_PathEntity,
    UpdatePDM_MA_PathEntity,
    DeletePDM_MA_PathEntity,
} from '@/api/pdm/ma/maPath'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmMaPath = {
    namespaced: true,
    state: {
        PdmMaPathList: [],
        PdmMaPathListLoading: false,
        PdmMaPathEntity: null,
        PdmMaPathShowDlg: false,
    },
    mutations: {
        setPdmMaPathList(state, dataList) {
            state.PdmMaPathList = [...dataList]
        },
        setPdmMaPathListLoading(state, visible) {
            state.PdmMaPathListLoading = visible
        },
        setPdmMaPathShowDlg(state, visible) {
            state.PdmMaPathShowDlg = visible
        },
        setPdmMaPathEntity(state, entity) {
            state.PdmMaPathEntity = entity
        },
    },
    actions: {
        //创建康复预约文件存储对象
        actCreatePdmMaPath({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_PathEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPathEntity', res.Data)
                        commit('setPdmMaPathShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载康复预约文件存储对象
        actGetPdmMaPathEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPathListLoading', true)
                GetPDM_MA_PathEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPathEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPathListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载康复预约文件存储列表
        actGetPdmMaPathList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPathListLoading', true)
                GetPDM_MA_PathList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPathList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPathListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载康复预约文件存储列表
        actGetPdmMaPathListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPathListLoading', true)
                GetPDM_MA_PathListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPathList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPathListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存康复预约文件存储信息
        actUpdatePdmMaPath({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_PathEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPathShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Path
        actEditPdmMaPathData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmMaPathID : entity.PdmMaPathID
                }
                GetPDM_MA_PathEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaPathEntity', res.Data)
                        commit('setPdmMaPathShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Path ,传对象过来
        actEditPdmMaPath({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaPathEntity', entity)
                commit('setPdmMaPathShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_Path
        actDeletePdmMaPath({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要执行删除操作？").onOk(() => {
                    DeletePDM_MA_PathEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaPathShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除康复预约文件存储失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


